import { useNavigate } from 'react-router-dom';

const AdminHeader = ({ onLogout }: { onLogout: () => void }) => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 w-full bg-gray-800 shadow-lg z-50">
      <div className="px-4 py-4 flex items-center justify-between">
        <div>
          <h1 className="text-white text-xl font-bold">Panel Admin</h1>
          <p className="text-gray-400 text-sm">Gestión del club</p>
        </div>
        <div className="flex items-center gap-2">
          <button 
            onClick={() => navigate('/')}
            className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
            title="Volver a la página principal"
          >
            <i className="ri-home-line text-lg"></i>
          </button>
          <button 
            onClick={onLogout}
            className="bg-pink-500 hover:bg-pink-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
            title="Cerrar sesión"
          >
            <i className="ri-logout-box-line text-lg"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
